import * as React from 'react';

import { cn } from './utils';

const Card = React.memo(function Card({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card"
      className={cn(
        'flex flex-col gap-6 rounded-xl border bg-card text-card-foreground',
        className
      )}
      {...props}
    />
  );
});

const CardHeader = React.memo(function CardHeader({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        '@container/card-header has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6',
        className
      )}
      {...props}
    />
  );
});

const CardTitle = React.memo(function CardTitle({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return <h4 data-slot="card-title" className={cn('leading-none', className)} {...props} />;
});

const CardDescription = React.memo(function CardDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <p data-slot="card-description" className={cn('text-muted-foreground', className)} {...props} />
  );
});

const CardAction = React.memo(function CardAction({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-action"
      className={cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className)}
      {...props}
    />
  );
});

const CardContent = React.memo(function CardContent({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-content"
      className={cn('px-6 [&:last-child]:pb-6', className)}
      {...props}
    />
  );
});

const CardFooter = React.memo(function CardFooter({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="card-footer"
      className={cn('[.border-t]:pt-6 flex items-center px-6 pb-6', className)}
      {...props}
    />
  );
});

export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
